import React from 'react';
import './JoiningPage.css';

const JoiningPage = () => {
    return (
        <div className="joining-page">
            <div className="joining-container">
                <h2>Postdoc Openings</h2>
                <p>Please contact Heng Yang directly if you are interested in a postdoc position.</p>
                
                <h2>PhD Openings</h2>
                <p>Please apply to the PhD programs at Harvard SEAS (e.g., in EE/CS/AM/ME) and list Heng Yang as a potential advisor.</p>

                <h2>Masters and Undergraduates</h2>
                <p>We are interested in working with self-motivated students with (a) a strong theoretical and computational background (e.g., applied math, optimization and control, statistics, machine learning, and scientific computing), and/or (b) rich experiences in real robotic platforms (e.g., drones, manipulators, ground vehicles).</p>

                <p>Due to the large volume of inquiries, we may not be able to reply to all emails.</p>
            </div>
        </div>
    );
};

export default JoiningPage;

